import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-432e90c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-h6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_page_sticky = _resolveComponent("q-page-sticky")!

  return (_openBlock(), _createBlock(_component_q_page_sticky, {
    class: "shadow-3",
    style: {"opacity":"0.93"},
    position: "top",
    offset: [0, 0],
    expand: "expand"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_toolbar, {
        class: _normalizeClass(_ctx.$q.dark.isActive ? 'bg-dark' : 'bg-white'),
        dense: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_item, {
            class: "full-width",
            dense: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, { side: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_btn, {
                    flat: "flat",
                    rounded: "",
                    icon: "arrow_back",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item_section, { class: "text-center" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.label), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_q_item_section, { side: "" }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ]),
                _: 3
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["class"])
    ]),
    _: 3
  }))
}